export default {
  // TISSUE

  create(data) {
    return env.API.post('/test/tissue/create', data);
  },

  getAllAnalysis(filter) {
    return env.API.post('/test/tissue/analysis/all', filter);
  },


  getAnalysis(analisis) {
    return env.API.get('/test/tissue/analysis/get', {
      params: {
        analysisId: analisis
      }
    });
  },


  getTissueTest(crop, variety, tissue, samplingTime) {
    return env.API.get('/test/tissue/get', {
      params: {
        cropId: crop,
        variety: variety,
        tissue: tissue,
        samplingTime: samplingTime,
      }
    });
  },


  getTissueByVariety(crop, variety) {
    return env.API.get('/test/tissue/getByVariety', {
      params: {
        cropId: crop,
        variety: variety,
      }
    });
  },


  getSamplingByTissue(crop, variety, tissue) {
    return env.API.get('/test/tissue/getByTissue', {
      params: {
        cropId: crop,
        variety: variety,
        tissue: tissue,
      }
    });
  },

  getBySamplingTime(crop, variety, tissue, samplingTime) {
    return env.API.get('test/tissue/getBySamplingTime', {
      params: {
        cropId: crop,
        variety: variety,
        tissue: tissue,
        samplingTime: samplingTime,
      }
    })
  },


  delete(analisis) {
    return env.API.post(`/test/tissue/delete`, {
      analysisId: analisis
    });
  },


  update(analisis, data) {
    return env.API.post(`/test/tissue/update`, {
      analysisId: analisis,
      ...data,
    });
  },

  downloadReport(id) {
    return env.API.get('test/tissue/' + id + '/report');
  },
}
